module.exports = __webpack_public_path__ + "img/voucher.b14e586a.svg";